import { get } from 'lodash'
import React, { useCallback } from 'react'

import { WrapperAction } from './WrapperAction'

import { GiCardExchange } from 'react-icons/gi'
import { useDisclosure } from '@chakra-ui/react'

import { ActionProps } from './types'
import { ModalAlterShippingMethod } from 'components/ModalAlterShippingMethod'

export const AlterShippingMethodAction = <T extends unknown>({
  record,
  options,
}: ActionProps<T>) => {
  const modalAlterShippingMethodDisclosure = useDisclosure()

  const { callback, actionType = 'menu', reload, ...optionsRest } = options

  if (!reload) {
    throw new Error('reload is required')
  }

  const purchaseId = get(record, 'id')

  const cta = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>, data: T) => {
      modalAlterShippingMethodDisclosure.onOpen()

      if (callback) {
        callback(e, data)
      }
    },
    [modalAlterShippingMethodDisclosure, callback]
  )

  return (
    <>
      <ModalAlterShippingMethod
        reload={reload}
        purchaseId={purchaseId}
        isOpen={modalAlterShippingMethodDisclosure.isOpen}
        onCancel={modalAlterShippingMethodDisclosure.onClose}
      />

      <WrapperAction
        cta={cta}
        record={record}
        icon={GiCardExchange}
        options={optionsRest}
        actionType={actionType}
        label="Mudar tipo de envio"
      />
    </>
  )
}
